import { render } from "./TeamInfo.vue?vue&type=template&id=32af4625"
import script from "./TeamInfo.vue?vue&type=script&lang=js"
export * from "./TeamInfo.vue?vue&type=script&lang=js"

import "./TeamInfo.vue?vue&type=style&index=0&id=32af4625&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__